module.exports = __webpack_public_path__ + "static/img/index.f2ff8b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index.jpg
// module id = Crk6
// module chunks = 0